import { useAtom } from "jotai";
import { useLayoutEffect, useMemo } from "react";

import { QuizProgressBar } from "../../../shared/components/lander-quiz-components/quiz-progress-bar/quiz-progress-bar.component";
import {
  landerCplQuizAtom,
  landerCplQuizGrantedEntriesAtom,
} from "../../lander-cpl-quiz.state";
import { entriesCount } from "../../utils";

export const LanderCplQuizHeader: React.FC = () => {
  const [landerCplQuiz] = useAtom(landerCplQuizAtom);
  const { cplQuizTitle } = window.FKL;
  const [, setLanderCplQuizGrantedEntries] = useAtom(
    landerCplQuizGrantedEntriesAtom
  );

  const questionsAnsweredCount = useMemo(
    () =>
      landerCplQuiz.questions.filter((question) => {
        return !!question.answer;
      }).length,
    [landerCplQuiz]
  );

  const totalEntries = useMemo(() => {
    const grantedEntries = entriesCount(
      landerCplQuiz.questions,
      landerCplQuiz.allTimePoints ?? 0
    );
    setLanderCplQuizGrantedEntries(entriesCount(landerCplQuiz.questions, 0));
    return grantedEntries;
  }, [
    landerCplQuiz.questions,
    landerCplQuiz.allTimePoints,
    setLanderCplQuizGrantedEntries,
  ]);

  useLayoutEffect(() => {
    const bottomAdsContainer = document.querySelector(
      "#lander-cpl-quiz-ads--bottom"
    ) as HTMLElement | null;

    if (bottomAdsContainer) bottomAdsContainer.classList.remove("hide");
  }, []);

  return (
    <div className="lander__cpl__quiz__header">
      <div className="lander__cpl__quiz__header--earned-entries">
        {`Your entries: ${totalEntries}`}
      </div>
      <span className="lander__cpl__quiz__header--description">
        {cplQuizTitle}
      </span>
      <QuizProgressBar
        branchedQuestionsCount={0}
        quizQuestionsCount={landerCplQuiz.questions.length}
        questionsAnsweredCount={questionsAnsweredCount}
      />
    </div>
  );
};
